export default __webpack_public_path__ + "static/media/sacredheart.d769a6f0.jpg";